import {A11yConsentApi} from './a11y-consent-api';
import {AbstractOption} from './abstract-option';
import {AbstractGroupData} from './types/abstract-group-data';
import {Logger} from './utilities/logger';
import mitt, {Emitter} from 'mitt';

/**
 * Base for a consent option group.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractGroup {
  // Emits events related to the group
  public readonly emitter: Emitter<any> = mitt<any>();

  // A11y Consent API
  public readonly api: A11yConsentApi;

  // UID
  public readonly uid: number;

  // Title
  public readonly title: string;

  // Description
  public readonly description: string;

  // Consent options of this group
  public readonly options: { [p: string]: AbstractOption } = {};

  // Number of available options
  public readonly optionsCount: number;

  /**
   * @param {A11yConsentApi} api A11y Consent API
   * @param {AbstractGroupData} data Group data from the global configuration object
   */
  protected constructor(api: A11yConsentApi, data: AbstractGroupData) {
    this.uid = data.uid;
    Logger.debug('abstract-group', `Starting to construct "${this.uid}".`);

    this.api = api;
    this.title = data.title;
    this.description = data.description;
    this.optionsCount = Object.keys(data.options).length;

    Logger.debug('abstract-group', `Finished constructing "${this.uid}".`);
  }
}
